import axios from 'axios'

const apiOrigin = (process.env.VUE_APP_API_URL || '').replace(/\/+$/, '')

export const instance = axios.create({
  baseURL: `${apiOrigin}/api/v1`,
  timeout: 5000
})

// 请求拦截器
instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
instance.interceptors.response.use(
  response => {
    if (response && response.data) {
      if (response.data.status === 500) {
        return Promise.reject(new Error(response.data.message))
      }
      return response.data
    }
    return response
  },
  error => {
    console.error('API 请求错误:', error)
    return Promise.reject(error)
  }
)

export const login = (data) => {
  return instance.post('/login', data)
}

export const sendEmail = (email) => {
  return instance.post(`/sendEmail/${email}`)
}

export const register = (data) => {
  return instance.post('/user/add', data)
}

export const getArticles = (params) => {
  return instance.get('/articles', { params })
}

export const getArticlesByCategory = (cid, params) => {
  return instance.get(`/article/list/${cid}`, { params })
}

export const getCategories = () => {
  return instance.get('/categorys')
}

export const addArticle = (data) => {
  return instance.post('/article/add', data)
}

export const editArticle = (id, data) => {
  if (!id || isNaN(parseInt(id))) {
    return Promise.reject(new Error('无效的文章ID'))
  }
  console.log('发送编辑请求:', {
    method: 'PUT',
    url: `/article/${id}`,
    data: data
  })
  return instance.put(`/article/${id}`, data)
}

export const deleteArticle = (id) => {
  if (!id || isNaN(parseInt(id))) {
    return Promise.reject(new Error('无效的文章ID'))
  }
  return instance.delete(`/article/${id}`)
}

// 添加分类
export const addCategory = (data) => {
  return instance.post('/category/add', data)
}

// 编辑分类
export const editCategory = (id, data) => {
  if (!id || isNaN(parseInt(id))) {
    return Promise.reject(new Error('无效的分类ID'))
  }
  console.log('发送编辑请求:', {
    url: `/category/${id}`,
    data: data
  })
  return instance.put(`/category/${id}`, data)
}

// 删除分类
export const deleteCategory = (id) => {
  if (!id || isNaN(parseInt(id))) {
    return Promise.reject(new Error('无效的分类ID'))
  }
  return instance.delete(`/category/${id}`)
}

// 获取文章详情
export const getArticleInfo = (id) => {
  return instance.get(`/article/info/${id}`)
}

// 搜索文章
export const searchArticles = (params) => {
  return instance.get('/articles/search', { params })
}

// 创建文章
export const createArticle = (data) => {
  return instance.post('/article/add', data)
}

// Todo数据同步接口
export const syncTodoData = (data) => {
  return instance.post('/todo/sync', data)
}

export default instance
